import React from "react"
import FullWidthImageCarouselItem from "./full-width-image-carousel-item"
import Marquee from "react-fast-marquee"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { generateRandomString } from "../../helpers/keys"

export default function FullWidthImageCarousel({ fullWidthCarouselImageItem }) {
  const htmlImageItems =
    fullWidthCarouselImageItem?.length > 0
      ? fullWidthCarouselImageItem.map((item) => {
          return (
            <FullWidthImageCarouselItem
              key={generateRandomString()}
              image={item.backgroundImage}
              position={SelectionFactoryHelper.getFromSelectionFactory(item.position, false)}
            />
          )
        })
      : null

  const settings = {
    speed: 25,
    children: htmlImageItems,
  }

  return (
    <div data-epi-property="FullWidthCarouselImageItem" className="full-width-image-carousel-container">
      <Marquee {...settings}></Marquee>
    </div>
  )
}
